import React, { useEffect, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { RiCloseLine, RiDeleteBin5Line } from "react-icons/ri";
import "./styles.scss";
import { GrFormClose } from "react-icons/gr";
// import BarLoader from "react-spinners/BarLoader";
import { SessionRequest } from "../../containers/mentoring-session-requests/MentoringSessionRequests";
import IconButton from "../../../../../shared/components/ui/icon-button/IconButton";
import OutlineButton from "../../../../../shared/components/ui/outline-button/OutlineButton";
import { RequestStatus } from "../../../../../shared/constants/Constant";
import Moment from "react-moment";
import { useFunctions } from "reactfire";
import ConfirmationModal from "../../../../../shared/components/confirmationModal/ConfirmationModal";
import { FiEdit } from "react-icons/fi";
import UserNotification from "../../../../../shared/components/Notification/UserNotification";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import { useHistory } from "react-router-dom";
import { VscOpenPreview } from "react-icons/vsc";
import { useAppContext } from "../../../../../contexts/app-context/AppContext";
import { DashboardMentoringPages } from "../../Mentoring";

export interface MSessionRequest extends SessionRequest {
  mentorName: string;
  teamName: string;
  memberName: string;
  memberNames: string[];
}

interface IProps {
  session: MSessionRequest;
  sessions: MSessionRequest[];
  onHide(): void;
  show: boolean;
  loading?: boolean;
  onReject?: (sessionId: string) => void;
}

const SessionPreview = (props: IProps) => {
  const [index, setIndex] = useState(0);
  const [currentSession, setCurrentSession] = useState(props.session);
  const [loading, setLoading] = useState(false);
  const [showRejectConformation, setShowRejectConformation] = useState(false);
  const [showDeleteConformation, setShowDeleteConformation] = useState(false);
  const { userRole } = useAppUser();
  const { push } = useHistory();

  useEffect(() => {
    if (index !== -1) setCurrentSession(props.sessions[index]);
  }, [index, props.sessions]);

  useEffect(() => {
    setCurrentSession(props.session);
  }, [props.session]);

  useEffect(() => {
    const ind: number = props.sessions.findIndex(
      (session) => session.id === props.session.id
    );
    setIndex(ind); //Dont remove the following comment.
  }, [props.show]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateMentorSessionRequestStatusFunction = useFunctions().httpsCallable(
    "updateMentorSessionRequestStatus"
  );

  const updateRequestStatus = (id: string, status: RequestStatus) => {
    setLoading(true);
    updateMentorSessionRequestStatusFunction({
      id,
      status,
    })
      .then(() => {
        setLoading(false);
        UserNotification({
          isSuccess: true,
          message: `Request successfully ${
            status === RequestStatus.DELETED ? "deleted" : "rejected"
          }`,
        });
        if (status === RequestStatus.REJECTED) {
          props.onReject && props.onReject(id);

          setCurrentSession((ps) => {
            const updated = {
              ...ps,
              status: RequestStatus.REJECTED,
            };
            return Object.assign({}, updated);
          });
        }

        if (status === RequestStatus.DELETED) {
          setShowDeleteConformation(false);

          props.onHide();
        }
      })
      .catch(() => {
        setLoading(false);
        UserNotification({
          isSuccess: false,
          message: `Request ${
            status === RequestStatus.DELETED ? "deletion" : "rejection"
          } failed`,
        });
      })
      .finally(() => {
        setShowDeleteConformation(false);
        setShowRejectConformation(false);
      });
  };

  const rejectButton = (): any => {
    return (
      <>
        <span className="d-md-none">
          <IconButton color="red" size="sm">
            <RiCloseLine />
          </IconButton>
        </span>
        <span className="action-button d-none d-md-block">
          <OutlineButton
            color="red"
            icon={<RiCloseLine />}
            onClick={() => setShowRejectConformation(true)}
          >
            Reject
          </OutlineButton>
        </span>
      </>
    );
  };

  const deleteButton = (): any => {
    return (
      <>
        <span className="d-md-none">
          <IconButton color="red" size="sm">
            <RiCloseLine />
          </IconButton>
        </span>
        <span className="action-button d-none d-md-block">
          <OutlineButton
            color="red"
            icon={<RiDeleteBin5Line />}
            onClick={() => {
              setShowDeleteConformation(true);
            }}
          >
            Delete
          </OutlineButton>
        </span>
      </>
    );
  };

  const createSession = (): any => {
    return (
      <>
        <span className="action-button">
          <OutlineButton
            color="green"
            icon={<FiEdit />}
            onClick={() => {
              push("/dashboard/sessions/create", currentSession);
            }}
          >
            Create session
          </OutlineButton>
        </span>
      </>
    );
  };

  const app = useAppContext();

  const moreInfor = (): any => {
    return (
      <span className="action-button">
        <OutlineButton
          color="light-blue"
          icon={<VscOpenPreview />}
          onClick={() => {
            app.pushBackURL(DashboardMentoringPages.MENTORING_SESSION_REQUESTS);
            push(`/dashboard/sessions/session/${currentSession.id}`);
          }}
        >
          View session
        </OutlineButton>
      </span>
    );
  };

  const setApplicationStatusColor = () => {
    switch (currentSession.status) {
      case RequestStatus.SCHEDULED:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#008ae6",
                height: 7,
                borderColor: "#008ae6",
                width: "100%",
              }}
            />
          </>
        );
      case RequestStatus.COMPLETED:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#00cc00",
                height: 7,
                borderColor: "#00cc00",
                width: "100%",
              }}
            />
          </>
        );
      case RequestStatus.PENDING:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#737373",
                height: 7,
                borderColor: "#737373",
              }}
            />
          </>
        );
      default:
        return (
          <>
            <hr
              style={{
                backgroundColor: "#e60000",
                height: 7,
                borderColor: "#e60000",
              }}
            />
          </>
        );
    }
  };

  const getActionButtons = (): any => {
    switch (currentSession.status) {
      case RequestStatus.REJECTED:
        return <></>;
      case RequestStatus.PENDING:
        return (
          <>
            {userRole.isModerator && createSession()}
            {userRole.isModerator && rejectButton()}
            {userRole.isMember && !userRole.isModerator && deleteButton()}
          </>
        );
      case RequestStatus.DELETED:
        return <></>;
      default:
        return <>{moreInfor()}</>;
    }
  };

  return (
    <div>
      <Modal
        show={props.show}
        onHide={props.onHide}
        size="xl"
        className="model-preview-sessions"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        {currentSession && (
          <Modal.Body className="content-wrapper">
            <Col lg={12}>{setApplicationStatusColor()}</Col>
            <Container style={{ height: "80%" }}>
              <Row className="h-100">
                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100">
                      <Col xs={12} className="p-0" style={{ height: "45%" }}>
                        {/* <GrFormClose
                        className="btn-close"
                        onClick={props.onHide}
                      /> */}
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index > 0 && (
                          <div className="action-icon">
                            <MdNavigateBefore
                              onClick={() => {
                                if (index > 0) {
                                  setIndex((ps) => ps - 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
                <Col xs={10} className="p-0 h-100">
                  <Container className="h-100">
                    <Row
                      style={{ height: "10%" }}
                      className="action-button-wrapper"
                    >
                      <Col xs={12}>
                        <div className="h-100 d-flex align-items-center justify-content-center">
                          {props.show && getActionButtons()}
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ height: "100%" }} className="pt-3">
                      <Col xs={12} className="content small-scroll">
                        <Container fluid>
                          <Row>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Mentor name:</strong>{" "}
                                {currentSession.mentorName}
                              </p>
                            </Col>
                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Member name:</strong>{" "}
                                {currentSession.memberName}
                              </p>
                            </Col>
                            {currentSession.teamName !== "PUBLIC-TEAM" && (
                              <Col xs={12} className="mt-3">
                                <p>
                                  <strong>Team name:</strong>{" "}
                                  {currentSession.teamName}
                                </p>
                              </Col>
                            )}

                            <Col xs={12} className="mt-3">
                              <p>
                                <strong>Requested On:</strong>{" "}
                                <Moment format="MM/DD/YYYY">
                                  {
                                    new Date(
                                      currentSession.createdAt?.seconds * 1000
                                    )
                                  }
                                </Moment>
                              </p>
                            </Col>
                          </Row>
                        </Container>
                      </Col>
                    </Row>
                  </Container>
                </Col>

                <Col xs={1} className="h-100 p-0">
                  <Container fluid className="h-100">
                    <Row className="h-100 p-0">
                      <Col
                        xs={12}
                        className="p-0 d-flex justify-content-center"
                        style={{ height: "45%" }}
                      >
                        <GrFormClose
                          className="btn-close"
                          style={{ marginTop: "20px", fontSize: "30px" }}
                          onClick={props.onHide}
                        />
                      </Col>
                      <Col xs={12} className="p-0" style={{ height: "55%" }}>
                        {index < props.sessions.length - 1 && (
                          <div className="action-icon">
                            <MdNavigateNext
                              onClick={() => {
                                if (index < props.sessions.length - 1) {
                                  setIndex((ps) => ps + 1);
                                }
                              }}
                            />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        )}
      </Modal>
      <ConfirmationModal
        children={{
          bodyText: "Are you sure you want to reject this request?",
          headerText: "Confirmation",
          confirmButtonText: "Reject",
          cancelButtonText: "Cancel",
          confirmButtonColor: loading ? "grayStatic" : "red",
        }}
        loading={loading}
        show={showRejectConformation}
        onCancel={() => !loading && setShowRejectConformation(false)}
        onConfirm={() =>
          !loading &&
          updateRequestStatus(currentSession.id, RequestStatus.REJECTED)
        }
      />
      <ConfirmationModal
        children={{
          bodyText: "Are you sure you want to delete this request?",
          headerText: "Confirmation",
          confirmButtonText: "Delete",
          cancelButtonText: "Cancel",
          confirmButtonColor: loading ? "grayStatic" : "red",
        }}
        loading={loading}
        show={showDeleteConformation}
        onCancel={() => !loading && setShowDeleteConformation(false)}
        onConfirm={() =>
          !loading &&
          updateRequestStatus(currentSession.id, RequestStatus.DELETED)
        }
      />
    </div>
  );
};

export default SessionPreview;
